import React from 'react'
import { motion } from 'framer-motion'
import { Megaphone, DollarSign, Users } from 'lucide-react'
import { useBrand } from '../branding/BrandProvider'

const AdvertisePage = () => {
  const brand = useBrand()
  return (
    <div className="pt-16 lg:pt-20 min-h-screen">
      <section className="section-padding py-20">
        <div className="container-max">
          <motion.div className="text-center mb-12" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
            <h1 className="text-5xl font-display font-bold text-white mb-4">Advertise
              <span className="text-gradient block">with {brand.siteName}</span>
            </h1>
            <p className="text-white/70 max-w-3xl mx-auto">Reach local fans, musicians, and venues with non-intrusive placements that perform.</p>
          </motion.div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[{
              icon: Megaphone, title: 'Sponsored Events', desc: 'Highlight your show in prime discovery slots'
            }, {
              icon: Users, title: 'Premium Profiles', desc: 'Boosted visibility for artists and venues'
            }, {
              icon: DollarSign, title: 'Marketplace Features', desc: 'Promote listings and store pages'
            }].map((f, i) => {
              const Icon = f.icon
              return (
                <motion.div key={f.title} className="glass-card p-8 text-center" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.1 }} viewport={{ once: true }}>
                  <Icon size={36} className="text-le-accent mx-auto mb-4" />
                  <h3 className="text-xl font-semibold text-white mb-2">{f.title}</h3>
                  <p className="text-white/70">{f.desc}</p>
                </motion.div>
              )
            })}
          </div>
        </div>
      </section>
    </div>
  )
}

export default AdvertisePage

